import type { RouteRecordRaw } from "vue-router";

// The routes for teams are under organizations, since its sub view
export const routes: RouteRecordRaw[] = [];
